<template>
  <div class="password">
    <el-dialog
      title="Reset Password"
      :visible.sync="dialogVisible"
      width="45%"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div v-if="isSuccess" style="min-height: 100px; color: #000">
        A confirmation has been sent to your email address. Please follow the
        instructions in the email to reset your password.
      </div>
      <el-form :model="form" ref="form" :rules="rules" v-else>
        <el-form-item
          class="labelStyle"
          label="Enter your account email address below and an email will be sent with instructions on how to reset your password.Registered user's email"
          prop="email"
          required
        >
          <el-input v-model="form.email" placeholder="Enter your email" />
        </el-form-item>
        <el-form-item>
          <el-button @click="submitForm" type="primary" class="login-btn"
            >Reset Password</el-button
          ><a
            style="
              color: #049bdb;
              margin: 0 10px;
              cursor: pointer;
              text-decoration: underline;
              font-weight: 200;
            "
            @click="$router.push('/regist')"
            >Register</a
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { resetPassword } from "@/api/login";
export default {
  name: "ForgotPassword",
  data() {
    return {
      dialogVisible: false,
      form: {
        email: "",
      },
      rules: {
        email: [
          {
            type: "email",
            message: "Enter the correct email address",
            trigger: ["blur", "change"],
          },
        ],
      },
      isSuccess: false,
    };
  },
  mounted() {},
  methods: {
    handleClose() {
      this.dialogVisible = false;
      this.isSuccess = false;
      this.form.email = "";
    },
    submitForm() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          resetPassword(this.form)
            .then((res) => {
              if (res.code == 200) {
                this.isSuccess = true;
              } else {
                this.$message.error(res.messages);
              }
            })
            .catch(() => {
              this.$message.error("Failed to send email");
            });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped></style>
<style>
.labelStyle .el-form-item__label {
  text-align: left;
  font-weight: 500;
}
.password .el-input__inner {
  height: 50px;
  line-height: 1;
  border: 1px solid #565656;
}
.password .el-dialog__title {
  font-weight: bold;
}
.password .el-button {
  width: 20%;
  display: inline-block;
}
@media (max-width: 996px) {
  .password .el-dialog {
    width: 80% !important;
  }
  .password .el-button {
    width: 65%;
    font-size: 11px;
    padding: 7px;
  }
  .password .el-dialog__header {
    padding: 10px 10px 10px 5px;
  }
  .password .el-form-item__label {
    padding: 10px 2px;
    font-size: 13px;
    line-height: 1;
  }
}
</style>
